import { breakpoints } from './breakpoints';
var xs = breakpoints.xs, sm = breakpoints.sm, md = breakpoints.md, lg = breakpoints.lg;
export var mediaSizes = {
    Mobile: { minWidth: xs.min, maxWidth: sm.max },
    Tablet: { minWidth: md.min, maxWidth: md.max },
    Desktop: { minWidth: lg.min },
    GreaterThanMobile: { minWidth: md.min },
    LessThanDesktop: { maxWidth: md.max },
};
export default mediaSizes;
//# sourceMappingURL=mediaSizes.js.map